import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-logo" onClick={() => setMenuOpen(false)}>
          <img
            src="/logo24.png"
            alt="Trenda"
            className="logo-icon"
          />
        </Link>

        <nav className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <Link
            to="/"
            className={location.pathname === '/' ? 'active' : ''}
            onClick={() => setMenuOpen(false)}
          >
            Home
          </Link>
          <Link
            to="/about"
            className={location.pathname === '/about' ? 'active' : ''}
            onClick={() => setMenuOpen(false)}
          >
            About
          </Link>
          <Link
            to="/support"
            className={location.pathname === '/support' ? 'active' : ''}
            onClick={() => setMenuOpen(false)}
          >
            Support
          </Link>
          <Link
            to="/privacy"
            className={location.pathname === '/privacy' ? 'active' : ''}
            onClick={() => setMenuOpen(false)}
          >
            Privacy Policy
          </Link>
          <a
            href="https://apps.apple.com"
            className="navbar-cta"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setMenuOpen(false)}
          >
            Download
          </a>
        </nav>

        <button
          className="navbar-hamburger"
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(o => !o)}
        >
          <span /><span /><span />
        </button>
      </div>
    </header>
  );
}
